import { Box, Grid, Typography } from '@mui/material';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { ReasonMaster, yesAndNoMasters } from '../../utils/constant';
import { checkifFatcaYes, checkValidationBasedOnDate } from '../../utils/utilityFunctions';
import { useFeatureToggles } from '../../utils/toggler';
import { ApplicationSectionHeading } from '../ApplicationSectionHeading';

export default function FatcaDetails({
  applicants = [],
  createdAt = '',
}: {
  applicants: Partial<Applicant>[];
  createdAt?: string;
}): JSX.Element {
  const dateFeatureToggles = useFeatureToggles();

  const { tin_declaration_validation_date } = dateFeatureToggles;
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <ApplicationSectionHeading title="FATCA" />
            {applicants.map((applicant, index: number) => {
              const title = [
                'First/Solo Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading sx={{ letterSpacing: 0.5 + 'px' }}>{title}</SubHeading>

                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      {applicant.fatcaCrsDocumentCheck && (
                        <Grid item xs={12} display="flex" alignItems={'flex-start'}>
                          <Typography
                            sx={{
                              fontSize: 15,
                              fontWeight: 700,
                              color: 'rgba(0, 0, 0, 0.6)',
                              letterSpacing: '0.5px',
                            }}>
                            {`Wish to upload FATCA-CRS Declaration`}
                          </Typography>
                        </Grid>
                      )}
                      {!applicant.fatcaCrsDocumentCheck && (
                        <>
                          <KeyValue
                            title={'Type Of Address Provided At KRA'}
                            description={applicant.typeOfAddressProvidedAtKRA}
                          />
                          <KeyValue
                            title={'Citizen of any country other than India'}
                            description={
                              yesAndNoMasters[
                                applicant?.citizenOfAnyCountryOtherThanIndia || '' || ''
                              ]
                            }
                          />
                          <KeyValue
                            title={'Country of birth is any country other than India'}
                            description={
                              yesAndNoMasters[applicant?.countryOfBirthOtherThanIndia || ''] || ''
                            }
                          />
                          <KeyValue
                            title={'Tax Resident Of Any Country Other Than India'}
                            description={
                              applicant.taxResidentOfAnyCountryOtherThanIndia === null
                                ? null
                                : applicant.taxResidentOfAnyCountryOtherThanIndia === true
                                ? 'Yes'
                                : 'No'
                            }
                          />
                          <KeyValue
                            title={'POA or a mandate holder who has an address outside India'}
                            description={
                              yesAndNoMasters[applicant?.poaMandateHolderOutsideIndia || ''] || ''
                            }
                          />
                          <KeyValue
                            title={'Address or telephone number outside India'}
                            description={
                              yesAndNoMasters[applicant?.addressTelephoneOutsideIndia || ''] || ''
                            }
                          />
                          <KeyValue title={'Place Of Birth'} description={applicant.placeOfBirth} />
                          <KeyValue
                            title={'Country Of Birth'}
                            description={applicant.countryOfBirth}
                          />
                          <KeyValue
                            title={'Country Of Nationality'}
                            description={applicant.countryOfNationality}
                          />
                          {checkifFatcaYes(
                            applicant?.taxResidentOfAnyCountryOtherThanIndia,
                            applicant?.citizenOfAnyCountryOtherThanIndia,
                            applicant?.countryOfBirthOtherThanIndia,
                            applicant?.poaMandateHolderOutsideIndia,
                            applicant?.addressTelephoneOutsideIndia
                          ) && (
                            <>
                              <KeyValue title={'Gender'} description={applicant.gender} />
                              <KeyValue
                                title={'Source of wealth'}
                                description={applicant.sourceOfWealth}
                              />
                              <KeyValue
                                title={'Tax Country Name'}
                                description={applicant.taxCountryName}
                              />
                              {checkValidationBasedOnDate(
                                createdAt || '',
                                tin_declaration_validation_date
                              ) && (
                                <KeyValue
                                  title={'TIN does not exist'}
                                  description={
                                    applicant.tinExists === null
                                      ? null
                                      : applicant.tinExists === true
                                      ? 'Yes'
                                      : 'No'
                                  }
                                />
                              )}
                              {((checkValidationBasedOnDate(
                                createdAt || '',
                                tin_declaration_validation_date
                              ) &&
                                !applicant?.tinExists) ||
                                !checkValidationBasedOnDate(
                                  createdAt || '',
                                  tin_declaration_validation_date
                                )) && (
                                <>
                                  <KeyValue title={'Tax ID'} description={applicant.taxID} />
                                  <KeyValue title={'Id Type'} description={applicant.idType} />
                                </>
                              )}
                              {checkValidationBasedOnDate(
                                createdAt || '',
                                tin_declaration_validation_date
                              ) &&
                                !applicant?.tinExists && (
                                  <KeyValue
                                    title={'Tin Verified'}
                                    description={
                                      applicant.isTinVerified && applicant.isTinVerified[0] != null
                                        ? applicant.isTinVerified[0] === true
                                          ? 'Tin verified successfully'
                                          : 'Tin verification failed'
                                        : null
                                    }
                                  />
                                )}
                              {applicant.idType === 'OTHERS' && (
                                <>
                                  <KeyValue
                                    title={'Please Specify ID Type'}
                                    description={applicant.idTypeOthers}
                                  />
                                  <KeyValue
                                    title={'Specify Reason (If TIN is not available)'}
                                    description={applicant.othersTinNotAvailableReason}
                                  />
                                </>
                              )}
                            </>
                          )}
                          {/* <KeyValue title={'Name Of Entity'} description={applicant.nameOfEntity} />
                      <KeyValue
                        title={'Date Of Incorporation'}
                        description={applicant.dateOfIncorporation?.split(' ')[0]}
                      />
                      <KeyValue
                        title={'City Of Incorporation'}
                        description={applicant.cityOfIncorporation}
                      />
                      <KeyValue
                        title={'Entity Excemption Code'}
                        description={applicant.entityExcemptionCode}
                      /> */}
                        </>
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
